//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            showHeader: false,
            // {
            //     name: 'Resident Crime Notice',
            //     description: '',
            //     type: 'User Generated',
            //     template_data: 'This is a notification from the staff at <Property_Name>.  We have been made aware of a crime happening in the area.  This is not meant to alarm you, but to remind you to follow the security guidelines as outlined in your lease contract.  More information can be found in your Resident Portal at <link>.'
            // }
            templates: []

        };
    },

    methods: {
        getTemplates: function getTemplates() {

            var self = this;

            window.axios.get('/prototype/notifications/templates').then(function (response) {

                var notes = response.data,
                    outputData = [];

                notes.forEach(function (n, index) {

                    var sentDate = moment(n.created_at);
                    // readDate = moment(n.marked_as_read_at)

                    var item = {
                        id: n.id,
                        name: n.subject,
                        type: n.user ? 'User Generated' : 'System Generated',
                        sent_date: sentDate.format('MMMM Do YYYY [at] h:mm:ss a'),
                        description: n.body
                    };

                    outputData.push(item);
                });

                self.templates = outputData;
            });
        },
        viewTemplate: function viewTemplate(idx) {
            Event.$emit('view-template', this.templates[idx]);
        },
        addTemplate: function addTemplate() {
            Event.$emit('new-notification');
        }
    },
    mounted: function mounted() {
        this.getTemplates();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/notifications/NotificationTemplates.vue
// module id = um/H
// module chunks = 0 1